import React, { useState } from "react"
import { Link, useI18next } from "gatsby-plugin-react-i18next"
import Container from "../Container"
import { Menu, Row, Col, Space, Button } from "antd"
import { CloseIcon } from "../Icon"
import TopNav from "./TopNav"

import { SocialLinkData } from "../../dummy/Global"
import useMenus from "../../hooks/useMenus"

import "./MainNav.less"

const { SubMenu } = Menu

export default function MenuMobile({ closeMenu }) {
  const { languages, originalPath, t, ...rest } = useI18next()
  const menus = useMenus()
  const [state, setState] = useState({
    current: "",
    visible: false,
  })

  const handleClick = e => {
    setState(p => ({ ...p, current: e.key }))
  }

  const { current } = state

  return (
    <>
      <nav className="header">
        <Container>
          <Row justify="space-between" align="middle">
            <Col flex="none">
              <Link to="/">
                <img
                  src={require("../../images/logo.png")}
                  srcSet={`${require("../../images/logo@2x.png")} 2x`}
                  alt="LPDP"
                  className="logo"
                />
              </Link>
            </Col>
            <Col flex="none">
              <Space size="large">
                <div>
                  {languages.map(function (lng, index) {
                    return (
                      <Button
                        type="link"
                        key={index}
                        style={{
                          color: "inherit",
                          fontWeight: lng === rest.language ? 700 : 400,
                        }}
                      >
                        <Link to={originalPath} language={lng}>
                          {(index ? "" : " | ") + lng}
                        </Link>
                      </Button>
                    )
                  })}
                </div>
                <Button type="link" onClick={closeMenu}>
                  <CloseIcon style={{ fontSize: "24px" }} />
                </Button>
              </Space>
            </Col>
          </Row>
        </Container>
      </nav>
      <Menu
        onClick={handleClick}
        selectedKeys={[current]}
        mode="inline"
        className="mobile-menu"
      >
        <Menu.Item key="home">
          <Link to="/">{t("Beranda")}</Link>
        </Menu.Item>
        {menus.map(function (item, i) {
          const { submenu, title, key, link, page_name } = item
          if (submenu !== undefined) {
            return (
              <SubMenu key={`mobile-${key}-${i}`} title={title}>
                {submenu.map(function (child, index) {
                  if (child.submenu !== undefined) {
                    return (
                      <SubMenu key={index} title={child.title}>
                        {child.submenu.map(function (subchild, index) {
                          return (
                            <Menu.Item key={`mobile-${subchild.key}-${i}-${index}`} data-page={`${subchild.page_name}`}>
                              <Link to={subchild.link}>{subchild.title}</Link>
                            </Menu.Item>
                          )
                        })}
                      </SubMenu>
                    )
                  } else {
                    return (
                      <Menu.Item key={`mobile-${child.key}-${i}-${index}`} data-page={`${child.page_name}`}>
                        <Link to={child.link}>{child.title}</Link>
                      </Menu.Item>
                    )
                  }
                })}
              </SubMenu>
            )
          } else {
            return (
              <Menu.Item key={`mobile-${key}`} data-page={`${page_name}`}>
                <Link to={link}>{title}</Link>
              </Menu.Item>
            )
          }
        })}
      </Menu>
      <TopNav
        address="Gedung Danadyaksa Cikini, Jl. Cikini Raya No.91A-D, Menteng, Jakarta Pusat"
        phone="1500-652"
      />
      <div className="text-center">
        <h3 className="footer-title">Ikuti Kami</h3>
      </div>
      <div style={{ maxWidth: 320, margin: "0 auto", paddingBottom: 30 }}>
        <Row align="center" gutter={20} justify="space-around">
          {SocialLinkData.map(function (item, i) {
            return (
              <Col flex="auto" key={i} className="text-center">
                <a href={item.url} rel="noopener noreferrer" target="_blank">
                  {item.icon}
                </a>
              </Col>
            )
          })}
        </Row>
      </div>
    </>
  )
}
